import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import zhTranslations from './locales/zh.json';
import khTranslations from './locales/kh.json';

// Translation resources loaded from external files
const resources = {
    en: {
        translation: enTranslations
    },
    zh: {
        translation: zhTranslations
    },
    kh: {
        translation: khTranslations
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
        defaultNS: 'translation',
        ns: ['translation'],
    });

export default i18n;
